import http from '@/communication/AuthConnection'

export default async ({ commit }, form) => {
  try {
    const formattedBidMirror = formatBidMirror(form.requirements)
    const request = await http.post('/v1/bid-mirror/save-bid-mirror', {
      eventId: form.eventId,
      requirements: formattedBidMirror
    })

    return request
  } catch (error) {
    return Promise.reject(error)
  }
}

const formatBidMirror = (data) => {
  let formattedBidMirror = []
  for (let category in data) {
    let requirementList = data[category].requirement
    for (let requirementDetails in requirementList) {
      const inputValue = requirementList[requirementDetails].inputValue
      if (!inputValue) continue

      const inputType = requirementList[requirementDetails].inputType
      const requirementId = requirementList[requirementDetails]._id
      const identification = requirementList[requirementDetails].identification

      const bidMirrorFields = {
        inputValue: inputValue,
        inputType: inputType,
        requirementId: requirementId
      }
      if (identification) {
        bidMirrorFields.identification = identification
      }
      formattedBidMirror.push(bidMirrorFields)

      let reqDetails = requirementList[requirementDetails].requirementDetail
      if (reqDetails) {
        for (let requirementDetail in reqDetails) {
          let reqDetail = reqDetails[requirementDetail]
          if (!reqDetail.inputValue) continue

          formattedBidMirror.push({
            inputValue: reqDetail.inputValue,
            inputType: reqDetail.inputType,
            requirementId: reqDetail._id
          })
        }
      }
    }
  }

  return formattedBidMirror
}



// WEBPACK FOOTER //
// ./src/brain/bid-mirror/SaveBidMirror.js